// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.threshold-button {
  position: fixed;
  z-index: 999999;
  font-size: 1.2rem;
  padding: 0.8rem 1.2rem;
  border: none;
  outline: none;
  background-color: #111;
  color: #fff;
  font-weight: 700;
  border-radius: 7px;
  cursor: pointer;
}

.threshold-button:hover {
  outline: 2px solid #000;
  outline-offset: 0.2rem;
}

.threshold-button:active {
  outline: 2px solid #000;
  outline-offset: 0.2rem;
  background-color: #444;
}

.threshold-beep-button {
  top: 1rem;
  right: 1rem;
}

.threshold-proceed-button {
  bottom: 0.5rem;
  /* right: 1rem; */
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}
`, "",{"version":3,"sources":["webpack://./components/css/instructions.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV","sourcesContent":[".threshold-button {\n  position: fixed;\n  z-index: 999999;\n  font-size: 1.2rem;\n  padding: 0.8rem 1.2rem;\n  border: none;\n  outline: none;\n  background-color: #111;\n  color: #fff;\n  font-weight: 700;\n  border-radius: 7px;\n  cursor: pointer;\n}\n\n.threshold-button:hover {\n  outline: 2px solid #000;\n  outline-offset: 0.2rem;\n}\n\n.threshold-button:active {\n  outline: 2px solid #000;\n  outline-offset: 0.2rem;\n  background-color: #444;\n}\n\n.threshold-beep-button {\n  top: 1rem;\n  right: 1rem;\n}\n\n.threshold-proceed-button {\n  bottom: 0.5rem;\n  /* right: 1rem; */\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
